import React from 'react';
import PropTypes from 'prop-types';

import Logo from './Logo';
import InnerFooter from './InnerFooter';
import withBrandContextProvider from '../../hoc/withBrandContextProvider';

const Layout = ({ children, brand }) => (
  <div className="c-vi-layout-wrapper">
    <div>
      <Logo />

      {children}
    </div>

    <InnerFooter shopName={brand && brand.name} />
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  brand: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withBrandContextProvider(Layout);



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Layout.jsx